import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

function list(params) {
  return request({
    url: ENDPOINT.IAM_RESOURCES,
    method: "get",
    params,
  });
}

async function show(id) {
  return await request({
    url: `${ENDPOINT.IAM_RESOURCES}/${id}`,
    method: "get",
  });
}

function create(data) {
  return request({
    url: ENDPOINT.IAM_RESOURCES,
    method: "post",
    data,
  });
}

function update(data) {
  return request({
    url: `${ENDPOINT.IAM_RESOURCES}/${data.id}`,
    method: "patch",
    data,
  });
}

function remove(data) {
  return request({
    url: `${ENDPOINT.IAM_RESOURCES}/${data.id}`,
    method: "delete",
    data,
  });
}

export default {
  list,
  show,
  create,
  update,
  remove,
};
